<div class="ldm" (click)="close('backdrop')" data-test="line-done-modal">
    <div class="ldm__card" role="dialog" aria-modal="true" aria-labelledby="ldm-title" (click)="$event.stopPropagation()">
        <button type="button" class="ldm__close" aria-label="Cerrar" (click)="close('close_button')" data-test="done-close">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" aria-hidden="true">
                <path d="M18 6 6 18M6 6l12 12" />
            </svg>
        </button>

        <span class="ldm__icon" aria-hidden="true">
            <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
                <path d="m22 7-8.5 8.5-5-5L2 17" />
                <path d="M16 7h6v6" />
            </svg>
        </span>
        <div class="ldm__brand">
            <img class="ldm__logo" src="assets/img/creditos/fina-presta-dark.png" alt="Fina Presta" data-test="done-logo" />
            <span class="ldm__eyebrow">{{ copy.eyebrow }}</span>
        </div>
        <h2 id="ldm-title" class="ldm__title" data-test="done-title">{{ title }}</h2>
        <p class="ldm__body" data-test="done-body">{{ body }}</p>

        <!-- Mini escalera: solo con `levels` -->
        <div *ngIf="steps.length" class="ldm__ladder" data-test="done-ladder">
            <div *ngFor="let step of steps; trackBy: trackByLevel" class="ldm-step" [class.ldm-step--current]="step.current">
                <div class="ldm-step__eyebrow">{{ copy.ladderLevel(step.level) }}</div>
                <div class="ldm-step__cap">
                    <span class="ldm-step__upto">{{ copy.ladderUpTo }}</span> {{ step.cap }}
                </div>
                <div class="ldm-step__cuotas">{{ copy.ladderCuotas(step.installmentsCount) }}</div>
            </div>
        </div>

        <div *ngIf="markNote" class="ldm__mark" data-test="done-mark-note">{{ markNote }}</div>

        <button type="button" class="ldm__cta" (click)="onCta()" data-test="done-cta">{{ ctaLabel }}</button>
    </div>
</div>
